import { t } from "../i18n";

/** Format a past timestamp using the same minute/hour/day thresholds as mobile. */
export function formatRelativeTime(
  timestamp: number | string | Date,
  now: number = Date.now(),
): string {
  const timestampMs =
    timestamp instanceof Date
      ? timestamp.getTime()
      : typeof timestamp === "number"
        ? timestamp
        : new Date(timestamp).getTime();
  const diffMinutes = Math.max(0, Math.floor((now - timestampMs) / 60000));
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffDays > 0) return t("commonDaysAgo", { days: diffDays });
  if (diffHours > 0) return t("commonHoursAgo", { hours: diffHours });
  if (diffMinutes > 0) return t("commonMinutesAgo", { minutes: diffMinutes });
  return t("commonJustNow");
}
